import { createAction, props } from '@ngrx/store';
import { StepId } from '../../services/interest-wizard.service';

export enum InterestWizardActions {
  InterestWizardStepSubmitted = '[Interest Wizard] step submitted',
  InterestWizardStepSkipped = '[Interest Wizard] step skiped',
  InterestWizardSteppedBack = '[Interest Wizard] stepped back',
  InterestWizardStepCanceled = '[Interest Wizard] step canceled',
}

export const interestWizardStepSubmitted = createAction(
  InterestWizardActions.InterestWizardStepSubmitted,
  props<
    | {
        step: 'partner';
        payload: {
          partnerCode: string;
          regionZip: string;
        };
      }
    | {
        step: 'two-factor-auth';
        payload: {};
      }
  >(),
);

export const interestWizardStepSkipped = createAction(
  InterestWizardActions.InterestWizardStepSkipped,
  props<{ step: StepId }>(),
);

export const interestWizardSteppedBack = createAction(
  InterestWizardActions.InterestWizardSteppedBack,
  props<{ step: StepId }>(),
);

export const interestWizardStepCanceled = createAction(
  InterestWizardActions.InterestWizardStepCanceled,
  props<{ step: StepId }>(),
);
